export const subtitles = {
    "1": {
        "startTime": 1.12,
        "endTime": 2.66,
        "transcript": "How old-arcit?",
        "translation": "How old are you?"
    },
    "2": {
        "startTime": 2.8200000000000003,
        "endTime": 5.73,
        "transcript": "About 78.",
        "translation": "About 78."
    },
    "3": {
        "startTime": 5.75,
        "endTime": 8.23,
        "transcript": "(Yugcetun-mi kituusit?) Seventy...",
        "translation": "(Who are you in Yup'ik?) Seventy..."
    },
    "4": {
        "startTime": 9.635,
        "endTime": 11.335,
        "transcript": "Seventy-eight?",
        "translation": "Seventy-eight?"
    },
    "5": {
        "startTime": 11.46,
        "endTime": 12.68,
        "transcript": "Yugcetun kituusit?",
        "translation": "Who are you in Yup'ik?"
    },
    "6": {
        "startTime": 12.865,
        "endTime": 14.695,
        "transcript": "Ayaginaraugua Yugtun.",
        "translation": "I'm Ayagina'ar in Yup'ik."
    },
    "7": {
        "startTime": 16.565,
        "endTime": 28.905,
        "transcript": "Kitak' inerquutiinek un'um kuigem waten cikuqerraarraarcelluku canek inerquutnek niitelarcit wall' nallunrillrusit?",
        "translation": "Okay, so what kinds of admonished did you hear or find out about the river down there when it first freezes like this?"
    },
    "8": {
        "startTime": 30.27,
        "endTime": 37.06,
        "transcript": "Waten-wa tua-i uksuarmi cikuqerraarqami mamturivailegmi ciku aarnarqetulria.",
        "translation": "When it first freezes in the fall like this before it gets thick, the ice is dangerous."
    },
    "9": {
        "startTime": 37.06,
        "endTime": 44.17,
        "transcript": "Cali im' waten makut ilii qenunaciarluku, qenunaciaraqluku.",
        "translation": "Parts of it also freeze late, they freeze late."
    },
    "10": {
        "startTime": 46.93,
        "endTime": 52.9,
        "transcript": "Tua-i-w' nenglaiteqtaarqan cikunaciaraqluku, nengllingraan-llu cali ilii cikunaciaraqluku.",
        "translation": "It freezes late when it warms up periodically, and some freeze late even when it's cold."
    },
    "11": {
        "startTime": 53.4,
        "endTime": 60.02,
        "transcript": "Cali cikuqerqani cali tua-i aarnarqaqluni mamtuvkenani.",
        "translation": "Also, it's still dangerously thin when it freezes."
    },
    "12": {
        "startTime": 61.555,
        "endTime": 66.375,
        "transcript": "Naw'un tua-i yuum taringesciigataa mamkilnguq aarnarqelria-llu.",
        "translation": "A person cannot tell where it's thin and dangerous."
    },
    "13": {
        "startTime": 66.89,
        "endTime": 77.29,
        "transcript": "Tau͡gaam ayarungqerquni ayarumikun tamaaggun cikuliurutkamek ayarukun yuvriraqluku pikuniu nallunriciiqekii.",
        "translation": "But if he has a staff and examines the ice with that staff, he will know."
    },
    "14": {
        "startTime": 78.075,
        "endTime": 81.525,
        "transcript": "Man'a ayaruq tua-i alerquutektullruarput",
        "translation": "We were instructed on how to use this staff"
    },
    "15": {
        "startTime": 82.075,
        "endTime": 90.035,
        "transcript": "Pegingasqevkenaku waten arcaqerluku uum nalliini waten uksuarmi aarnarqellran nalliini yuvriutekluku.",
        "translation": "That we should not be without it, especially in the fall when it's dangerous like this, to examine the ice with."
    },
    "16": {
        "startTime": 90.41,
        "endTime": 98.62,
        "transcript": "Cukangnaq'nge'rmi arulaiqerluni man'a paqnakek'ni cikuliurutkun tuaggun yuvrirraarluku",
        "translation": "Even if he's in a hurry, after stopping and examining the place he's curious about with that tool"
    },
    "17": {
        "startTime": 98.92,
        "endTime": 106.76,
        "transcript": "Mamkitellra nallunriciiqaa. Aarnarqellra nallunriciiqaa. Cikuliurutiin apertuuciiqaa.",
        "translation": "He will know where it's thin. He will know where it's dangerous. His ice pick will show him."
    },
    "18": {
        "startTime": 108.765,
        "endTime": 115.945,
        "transcript": "Yuk-mi pitsaqa'artevkenani igtellrakun, cikukun igtellrakun qaillun ellminek ikayuryugngaa?",
        "translation": "So how cam a person who accidentally falls through the ice help himself?"
    },
    "19": {
        "startTime": 117.26,
        "endTime": 123.63,
        "transcript": "Waten cali qanrutetullruanga atama yuut-wa tua-i allat-llu:",
        "translation": "This is what my father and other people used to tell me:"
    },
    "20": {
        "startTime": 124.32,
        "endTime": 136.44,
        "transcript": "Waten alqunaq tua-i kiskan pugtakan, egmian tua-i tagesqevkenaku, qamenritengnaqluku pisqelluku.",
        "translation": "If he suddenly falls into the water and is floathing, that he should not go out right away, but try to keep the hole from closing up."
    },
    "21": {
        "startTime": 137.775,
        "endTime": 144.825,
        "transcript": "Qamkuni tua-i egmian-llu nugengnaq'leryagluni pikuni im'utun piniarciiquq.",
        "translation": "If it closes off and he tries to go out of the water right away, he will become weak."
    },
    "22": {
        "startTime": 145.465,
        "endTime": 149.635,
        "transcript": "Tau͡gaam tua-i mulngakluni pinaqluni pisqelluku.",
        "translation": "But they said that he needs to be careful."
    },
    "23": {
        "startTime": 149.645,
        "endTime": 155.775,
        "transcript": "Waten unisteḿa pitullruanga: nengelmi-gguq, nenglliqan-gguq aliimatengqerquma",
        "translation": "This is what my late father used to tell me: if it's cold and I have gloves"
    },
    "24": {
        "startTime": 156.885,
        "endTime": 166.305,
        "transcript": "Waten tua-i maavet cikumun waten imerqellukek waten pirraarlukek pavavet patkaullukek cikumun qenuqautellukek.",
        "translation": "After placing them on the ice here like this, slap them on the ice up there and let them freeze."
    },
    "25": {
        "startTime": 166.83,
        "endTime": 170.14,
        "transcript": "Taukuk-gguq tua-i tegumiaqlukek nugyugngauq yuk.",
        "translation": "He said that a person can hold those and pull himself out."
    },
    "26": {
        "startTime": 170.47,
        "endTime": 180.81,
        "transcript": "Cali irugni ciumek nuggluku, una-llu tegumiaqluku akagluni, kelutmun akagluni piarkauluni.",
        "translation": "Also, he should take his legs out first, then hold this and roll, he must roll out of the water."
    },
    "27": {
        "startTime": 181.455,
        "endTime": 185.885,
        "transcript": "Tua-i call' tamaa-i tamana ellminek anirturyugngauq qamenrilkuni.",
        "translation": "He can also save himself if the ice didn't close in on him."
    },
    "28": {
        "startTime": 186.285,
        "endTime": 197.345,
        "transcript": "Tau͡gaam qamkuni cali tua-i ellminek egmian, tua-i-w' taqsuqa'artellriatun piluni piciquq",
        "translation": "But if it closes in on him right away, he will suddenly become tired"
    },
    "29": {
        "startTime": 198.02,
        "endTime": 201.46,
        "transcript": "Patagmek nugengnaq'leryagluni pikuni.",
        "translation": "If he tries to get out right away."
    },
    "30": {
        "startTime": 201.465,
        "endTime": 208.705,
        "transcript": "Tau͡gaam imkucirluni-w' tua-i, qamenritengnaqluni, tuaten cali alerqutullruitkut.",
        "translation": "But, you know, they would instruct us to try to keep the hole from closing in on us."
    },
    "31": {
        "startTime": 209.12,
        "endTime": 215.31,
        "transcript": "Assirluni-mi nugkuni qaillun pillran anirturciqau?",
        "translation": "But what will save him if he gets out safely?"
    },
    "32": {
        "startTime": 215.62,
        "endTime": 220.27,
        "transcript": "Waten nengelmi waten-llu qanikcangvailgan",
        "translation": "In the cold like this before there is snow"
    },
    "33": {
        "startTime": 221.11,
        "endTime": 229.46,
        "transcript": "Nugkuni tua-i egmianun aturani yuulaagluki nuna canimelkan man'a, can'get-ll' alailkata.",
        "translation": "When he gets out, he should take off his clothes right away if the land is close and there is grass visible."
    },
    "34": {
        "startTime": 229.78,
        "endTime": 235.98,
        "transcript": "Ciulaagluki tua-i matarrluni tua-i yuulaagluki mecungelriit.",
        "translation": "He should take off his wet clothes and wring them."
    },
    "35": {
        "startTime": 236.155,
        "endTime": 241.455,
        "transcript": "Ataam-llu all'uki, canegnek ekiirluku man'a qaini.",
        "translation": "And put them on again, lining his body with grass."
    },
    "36": {
        "startTime": 242.88,
        "endTime": 247.67,
        "transcript": "Tua-i cali nasperturluni qerrusngiinaqani",
        "translation": "Also, he must make calculated decisions if he's getting cold"
    },
    "37": {
        "startTime": 251.03,
        "endTime": 261.66,
        "transcript": "Qurrengnaqluni teq'uminek ellii meq'uni, elliin teq'uminek-wa tua-i kiimelkuni, wall' malruukunek aipami teq'urranek, qurrsungalriim teq'urranek meq'uni",
        "translation": "If he tries to urinate and drinks his urine, his own urine if he's alone, or if there's two of them, if he drinks his companions urine, whoever needs to urinate"
    },
    "38": {
        "startTime": 261.84,
        "endTime": 264.79,
        "transcript": "Qerrungaituq-gguq tuaten tua-i yuk pikuni.",
        "translation": "They say a person will not freeze to death if he does that."
    },
    "39": {
        "startTime": 264.89,
        "endTime": 270.33,
        "transcript": "Tamana tamaa-i nallunritarkaqsaaqaat makut ayagyuat.",
        "translation": "These young people must know that."
    },
    "40": {
        "startTime": 270.385,
        "endTime": 276.265,
        "transcript": "Cumacikevkenaku aipami-ll' teq'urranek meq'uni tua-i qerrungairuciiquq-gguq.",
        "translation": "If he's not repulsed and drinks his companion's urine, they say he will not freeze to death."
    },
    "41": {
        "startTime": 276.37,
        "endTime": 283.4,
        "transcript": "Amlleret atulallrulliniat. Tamakut atulartellrin qanrutkelallruat alerquutekluku.",
        "translation": "Many used to do that. Those who used to do that would instruct that."
    },
    "42": {
        "startTime": 284.94,
        "endTime": 290.89,
        "transcript": "Cali-llu-qaa man'a waten ayagpailegmi ilaminek qanrucilleq cali tamana ikayuutnguluni?",
        "translation": "Does it also help to tell families before traveling?"
    },
    "43": {
        "startTime": 291.15,
        "endTime": 291.74,
        "transcript": "Camek?",
        "translation": "What?"
    },
    "44": {
        "startTime": 291.76,
        "endTime": 299.36,
        "transcript": "Iciw' ayagpailegmi tuavet piqatarniluni qanrucimaurluki? Cat-llu tamatukun yugnun ikayuutngugngaat?",
        "translation": "You know, telling people that he's going to go to that place. How can that be of help to people?"
    },
    "45": {
        "startTime": 299.495,
        "endTime": 309.945,
        "transcript": "Ii-i, tua-i-w' yuk cali natmun ayakataquni qanrucugngayaaqekai ilani tamaatmun ayagciqniluni, natmun tuavet ayakatarniluni.",
        "translation": "Yes, a person can tell his family if he's going to travel somewhere that he's going to travel to someplace there."
    },
    "46": {
        "startTime": 310.985,
        "endTime": 319.275,
        "transcript": "Tua-i taukut kingunrin tekitellerkani pellukaku tua-i ayallra ciumek paqciiqaat ullagyullra.",
        "translation": "If it's past the time he should've came back, the people from his hometown will go first to where he wanted to go."
    },
    "47": {
        "startTime": 319.495,
        "endTime": 325.665,
        "transcript": "Pitsaqevkenaku cavkenaku tekiskunegteggu tua-i natmun ayaganrilkan piarkauluni",
        "translation": "If they happen to come upon him without any misfortune if he doesn't wander about"
    },
    "48": {
        "startTime": 326.025,
        "endTime": 328.075,
        "transcript": "Nalaqerkauluku tamaa",
        "translation": "They will find him right away"
    },
    "49": {
        "startTime": 329.005,
        "endTime": 332.615,
        "transcript": "Waten qimagalriatun ayaggarrluni natmun pileryanrilkan.",
        "translation": "If he doesn't stray anywhere."
    },
    "50": {
        "startTime": 336.245,
        "endTime": 337.395,
        "transcript": "Allamek-qaa...",
        "translation": "Anything else..."
    },
    "51": {
        "startTime": 340.435,
        "endTime": 347.005,
        "transcript": "Alerquutet makut yuum nallunrilkuniki, murilkelluki pikuniki ayagyuat makut",
        "translation": "If people, these young people, know these instructions and adhere to them"
    },
    "52": {
        "startTime": 347.005,
        "endTime": 352.375,
        "transcript": "Ayagyuat makut arcaqerluteng maa-i callerkarteng ilaita nalluat.",
        "translation": "These young people, especially now, do not know what they should do."
    },
    "53": {
        "startTime": 352.805,
        "endTime": 357.825,
        "transcript": "Taumek tamaa-i nallunritevkangnaqluki angayuqrita piarkauyaaqait",
        "translation": "That's why their parents must teach them about those"
    },
    "54": {
        "startTime": 358.13,
        "endTime": 363.98,
        "transcript": "Qalaruqu'urluki mat'umek aarnarqellriamek uum nalliini arcaqerluki aarnarqellran.",
        "translation": "Always talking to them about dangerous things especially now in these dangerous times."
    },
    "55": {
        "startTime": 363.98,
        "endTime": 368.11,
        "transcript": "Cali makut kuiget alerquutekluki.",
        "translation": "Also instruct them on these rivers."
    },
    "56": {
        "startTime": 368.38,
        "endTime": 376.17,
        "transcript": "Ilait kuiget mamtullrung'e'rmeng nenglairtaqan wanirpak aarnariqertetuut cukamek.",
        "translation": "Even though some rivers were thick, they quickly become dangerous when it warms up."
    },
    "57": {
        "startTime": 376.54,
        "endTime": 384.73,
        "transcript": "Tamakut cali una ayaruq tua-i tegumiaqerkaqaa yuum ayagallermini ayaruitarkauvkenani.",
        "translation": "Then this staff as well, a person must not be without a staff when he's traveling."
    },
    "58": {
        "startTime": 384.87,
        "endTime": 389.25,
        "transcript": "Tamakucingqerquni ayarungqerquni tua-i aarnarqellria nallunriciiqaa.",
        "translation": "If he has a staff like that, he will know what parts are dangerous."
    },
    "59": {
        "startTime": 389.255,
        "endTime": 394.735,
        "transcript": "Tamaaggun cikuliurutkun ayarumikun taringaqluku aarnarqellria.",
        "translation": "He will know which parts are dangerous with that staff he uses on the ice."
    },
    "60": {
        "startTime": 395.03,
        "endTime": 400.95,
        "transcript": "Alerquutet amllerrsaaqut makut ayagyuat nallunritarkaqsaaqek'ngait.",
        "translation": "There are a lot of instructions that these young people are supposed to know."
    },
    "61": {
        "startTime": 401.025,
        "endTime": 406.025,
        "transcript": "Tau͡gaam qanrutkumayuilata maa-i makut kinguqlimta arcaqerluteng nalluat",
        "translation": "But because we don't speak abou tthem, our successors espcially do not know them"
    },
    "62": {
        "startTime": 406.27,
        "endTime": 410.82,
        "transcript": "Qalarucimayuilameng, qalaruquraumayuilameng.",
        "translation": "Because we do not teach them."
    },
    "63": {
        "startTime": 411.22,
        "endTime": 416.96,
        "transcript": "Imumi ak'a avani ellangeqarraallemteńi wangkuta waten ellilriani",
        "translation": "Long ago when we who are this age were growing up"
    },
    "64": {
        "startTime": 417.265,
        "endTime": 423.665,
        "transcript": "Qasgimi angutet quyungqatullruameng tan'gurrateng makut ayagyuateng ilakluki",
        "translation": "Because they men would be gathered in the community house alnog with the young boys"
    },
    "65": {
        "startTime": 424.08,
        "endTime": 433.72,
        "transcript": "Taumek tamaa-i tamaaggun murilketalriim ayagyuam nallunritai tamakut alerquutet.",
        "translation": "That's why observant young people know those instructions."
    },
    "66": {
        "startTime": 433.855,
        "endTime": 437.515,
        "transcript": "Alerquutet makut yuum aarcirtuutekluki.",
        "translation": "A person uses these instructions as forewarning."
    },
    "67": {
        "startTime": 437.68,
        "endTime": 444.74,
        "transcript": "Nallunrilkuniki tua-i picurlagang'e'rmi utumaluni picurlagangaituq.",
        "translation": "If he knows them, even if he gets into misfortune, he will be better and will not get into too much misfortune."
    },
    "68": {
        "startTime": 445.525,
        "endTime": 448.865,
        "transcript": "Tua-i nallunritarkaqsaaqekait makut ayagyuat.",
        "translation": "These young people should know them."
    },
    "69": {
        "startTime": 449.48,
        "endTime": 455.95,
        "transcript": "Makut ciulirneret makut qantulliniut ellaita atullmeggnek",
        "translation": "These elders talk about what they've experienced"
    },
    "70": {
        "startTime": 456.34,
        "endTime": 468.04,
        "transcript": "Cali-ll' niitellmeggnek ciulirnemeng au͡gkut cali qanellritnek niitellmeggnek qalarucitulliniut makunun ayagyuanun elluarrluki atuusqelluki, elluarrluku pillerkaatnek.",
        "translation": "They also talk about the things they've heard their elders say long ago so that these young people will use them well, so that they will live well."
    },
    "71": {
        "startTime": 468.505,
        "endTime": 473.275,
        "transcript": "Elluarrluki-w' ayallerkaatnek pingnatugallratni-llu.",
        "translation": "So that they will live well including when they make their own living."
    },
    "72": {
        "startTime": 473.495,
        "endTime": 483.345,
        "transcript": "Tuaten tua-i nallunrilkuniu ayagyuam, alerquutet nallunrilkuniki ellminek tua-i ikayualuku man'a unguvallerkani piciquq",
        "translation": "If a young person knows it liek that, if he knows the instructions, he will be helping his life in the future"
    },
    "73": {
        "startTime": 483.375,
        "endTime": 487.695,
        "transcript": "Aarnarqelriit tuaten yuvrirturluki pitukuni.",
        "translation": "If he keeps examining those dangerous things."
    },
    "74": {
        "startTime": 488.12,
        "endTime": 497.17,
        "transcript": "Makut snuukuut makut tua-i ayagassuutekellrat nalluat man'a, aarnarqellria-llu nalluluku.",
        "translation": "These snowgoes do not know which way to travel, and they don't know what's dangerous."
    },
    "75": {
        "startTime": 497.57,
        "endTime": 504.72,
        "transcript": "Tau͡gaam imumi qimugtengqetullemteńi qimugtet makut aarnarqellria nalluyuitellruat.",
        "translation": "But back when we had dogs, the dogs knew which places were dangerous."
    },
    "76": {
        "startTime": 505.53,
        "endTime": 513.44,
        "transcript": "Taumek maa-i snuukuutgun-ll' ayange'rmi natmun kanaqataquni-ll' kuigmun tua-i yuvriqerrlainarluku.",
        "translation": "That's why when they're traveling with snowgos, they should always examine it when they're going to go down to the river."
    },
    "77": {
        "startTime": 513.44,
        "endTime": 519.16,
        "transcript": "Cali makut, makut cali kianellret cikuqallri nallunaitetuyaaqut.",
        "translation": "It's also easy to tell when previously unfrozen holes have frozen over."
    },
    "78": {
        "startTime": 519.835,
        "endTime": 531.475,
        "transcript": "Cikunaciaqallri-llu akaarnun anuqliraqluni pillrukan, man'a ceńii man'a kuigem kianellrem taum ceńii maniani qertuluni ciqertautellra man'a anuqmi.",
        "translation": "And where it froze late if there has been windy for a long time, the places where the unfrozen holes splash out in the wind, their edges in the river are rough and higher."
    },
    "79": {
        "startTime": 531.71,
        "endTime": 536.62,
        "transcript": "Tua-i call' tauna ciku manigcetellria cikukegtaar yuvrirrlainarluku.",
        "translation": "Also, we should always check the good smooth ice."
    },
    "80": {
        "startTime": 536.93,
        "endTime": 543.14,
        "transcript": "Ilii tua-i uingayunaunani cikunerra'arqii kitnarqeciqluni.",
        "translation": "They shouldn't try parts of it because they may fall through the freshly frozen parts."
    },
    "81": {
        "startTime": 543.42,
        "endTime": 546.96,
        "transcript": "Tamatukun tau͡gaam ayarukun yuvriqarraarrlainarluku.",
        "translation": "But they should always examine it with that staff first."
    },
    "82": {
        "startTime": 547.125,
        "endTime": 552.495,
        "transcript": "Cukangnaq'nge'rmi yuvriqarraarrlainarluku.",
        "translation": "Always examine it first even if he's in a hurry."
    },
    "83": {
        "startTime": 553.155,
        "endTime": 559.915,
        "transcript": "Cali waten ayagyuat makut ayagakuneng-wa tua-i ayagakuni im' alerquutektulput cali:",
        "translation": "This was also our instructions when young people would travel like this:"
    },
    "84": {
        "startTime": 560.59,
        "endTime": 566.48,
        "transcript": "Canek qelquciqerrlainarluni cali cikuliurun qanickiurun-llu ek'arrluku.",
        "translation": "He must always keep things with him, putting in an ice pick and a shovel."
    },
    "85": {
        "startTime": 566.73,
        "endTime": 572.5,
        "transcript": "Cali-llu kangicira'ar una cali tua-i uqamalkevkenaku malikerrlainarluku.",
        "translation": "Also, always go with a tarpaulin without saying it's too heavy."
    },
    "86": {
        "startTime": 573.14,
        "endTime": 584.56,
        "transcript": "Cali waten-llu pellaakuni ellaqerruskani-llu egmian cali ayagiinarpek'nani ayuquciireskuni arulairluni uitaurquni assinruciquq.",
        "translation": "Also, if one is lost and the weather turns on them, it will be better if he doesn't go any further when he doesn't know where he is anymore, but stop and stay where he is."
    },
    "87": {
        "startTime": 584.575,
        "endTime": 587.985,
        "transcript": "Uitaurpek'nani-w' tua-i urumangnaqu'urluni tau͡gaam nengelmi.",
        "translation": "Not staying still, but trying to stay warm in the cold."
    },
    "88": {
        "startTime": 588.245,
        "endTime": 595.625,
        "transcript": "Uitaurpek'nani, aqumgaurpek'nani ellminek urumangnaqluni pikuni ayagiinarpek'nani.",
        "translation": "Do not stay still and sit, but try to keep warm without going any further."
    },
    "89": {
        "startTime": 597.01,
        "endTime": 602.25,
        "transcript": "Imutun ayagiinaquni yaaqvanun tua-i ayagciquq, kiituan kaassairutuq.",
        "translation": "If he keeps going, he will go far until he eventually runs out of gas."
    },
    "90": {
        "startTime": 603.135,
        "endTime": 608.395,
        "transcript": "Yuararstekain-llu-am tua-i nalaqnaciarumaluku tuaten ayagallrukan.",
        "translation": "And those looking for him will not find him right away if he continued traveling like that."
    }
};